export default "__VITE_ASSET__fG4njw2S__"